module.exports = __webpack_public_path__ + "img/dokhan.6fd0044a.png";